<template>
  <page>
    <module :title="detail.title || (isNotice ? '公告详情' : '教程详情')">
      <div v-if="!isNotice && detail.category_name" class="article-meta">{{ detail.category_name }}</div>
      <div v-html="detail.content" class="agreement-content" />
    </module>
  </page>
</template>

<script>
export default {
  props: {
    article_type: {
      type: String,
      required: true
    },
    id: String
  },
  data() {
    return { detail: {} };
  },
  computed: {
    isNotice() {
      return this.article_type === '1';
    }
  },
  mounted() {
    this.loadDetail();
  },
  watch: {
    '$route.fullPath'() {
      this.loadDetail();
    }
  },
  methods: {
    loadDetail() {
      const id = this.id;
      const article_type = this.article_type;
      this.detail = {};
      this.request({
        url: "/article/published/detail",
        data: { id, article_type },
        success: data => {
          if (this.id !== id || this.article_type !== article_type) return;
          this.detail = data || {};
          if (data && data.id && ['1', '2'].includes(article_type)) {
            this.$nextTick(() => {
              if (this._isDestroyed || this.id !== id || this.article_type !== article_type) return;
              this.request({
                url: "/article/published/read",
                data: { id, article_type }
              });
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.article-meta {
  margin-bottom: 20px;
  color: #999;
  font-size: 13px;
}
.agreement-content {
  padding: 20px 32px;
  line-height: 28px;
  font-size: 14px;
}
</style>
